import { DatePeriodQuery, PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { GetProgramScheduleGroup, ProgramScheduleGroup } from '@models/program-schedule';
import { apiClient } from '.';

const BASE_URL = '/admin/v1/program-schedule-groups';

export const searchProgramScheduleGroups = async (query: SearchPagenateQuery & DatePeriodQuery) => {
  return apiClient.get<PagenatedResponse<GetProgramScheduleGroup>>(BASE_URL, { params: query });
};

export const getProgramScheduleGroup = async (id: string) => {
  return apiClient.get<GetProgramScheduleGroup>(`${BASE_URL}/${id}`);
};

export const updateProgramScheduleGroup = async (id: string, data: Partial<ProgramScheduleGroup>) => {
  return apiClient.patch<ProgramScheduleGroup>(`${BASE_URL}/${id}`, data);
};

export const deleteProgramScheduleGroup = async (id: string) => {
  return apiClient.delete<any>(`${BASE_URL}/${id}`);
};

export const addSchedulesToGroup = async (groupId: string, scheduleIds: string[]) => {
  return apiClient.post<ProgramScheduleGroup>(`${BASE_URL}/${groupId}/schedules`, { scheduleIds });
};

export const removeSchedulesFromGroup = async (groupId: string, scheduleIds: string[]) => {
  return apiClient.delete<ProgramScheduleGroup>(`${BASE_URL}/${groupId}/schedules`, { data: { scheduleIds } });
};
